import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Project } from '@depagne/types';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-client-project-modal',
  templateUrl: './add-client-project-modal.component.html',
  styleUrls: ['./add-client-project-modal.component.scss'],
})
export class AddClientProjectModalComponent implements OnInit {
  projectForm = this.fb.group({
    name: ['', Validators.required],
    description: [''],
  });

  constructor(
    public dialogRef: MatDialogRef<AddClientProjectModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      project: Project;
    },
    private fb: FormBuilder,
  ) {
    const { name, description, client, company, reduction } = data.project;

    console.log(data.project);

    this.projectForm.patchValue({
      name,
      description,
    });
  }

  ngOnInit(): void {}

  onSubmit() {
    console.log(this.projectForm.value);
    this.dialogRef.close({
      ...this.data.project,
      ...this.projectForm.value,
    });
  }
}
